import { toNgbDateStruct } from 'utils';
import { IPlace } from 'app/model/paziente';
import { Config } from 'app/config.const';
import { CodiceFiscale } from 'app/model/codice_fiscale';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { Component } from '@angular/core';
import { IPaziente } from 'app/model/paziente';
import { FormGroup, FormControl } from '@angular/forms';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { switchAll, tap, combineLatest, map, debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { Luoghi } from 'app/model/luoghi';
import * as Fuse from 'fuse.js';
import { isString } from 'util';
import { AlertDialogComponent } from 'app/components/dialog/dialog';

@Component({
	selector: 'app-newpatient',
	templateUrl: './newPatient.html',
	styleUrls: ['./../anagrafica.css']
})
export class NewPatientComponent {
	minDate = { year: 1900, month: 1, day: 1 };
	maxDate = { year: new Date().getFullYear() + 1, month: 1, day: 1 };

	formGroup = new FormGroup({
		nome: new FormControl(),
		cognome: new FormControl(),
		codicefiscale: new FormControl(),
		genere: new FormControl(),
		famiglia: new FormControl(),
		luogoNascita: new FormControl(),
		prNascita: new FormControl(),
		nazione: new FormControl(),
		cittadinanza: new FormControl(),
		resCitta: new FormControl(),
		resIndirizzo: new FormControl(),
		resNumciv: new FormControl(),
		resPr: new FormControl(),
		resCap: new FormControl(),
		recCitta: new FormControl(),
		recIndirizzo: new FormControl(),
		recNumciv: new FormControl(),
		recPr: new FormControl(),
		recCap: new FormControl(),
		telCasa: new FormControl(),
		telUfficio: new FormControl(),
		fax: new FormControl(),
		cell: new FormControl(),
		emailCasa: new FormControl(),
		emailUfficio: new FormControl(),
		sitoWeb: new FormControl()
	});
	paziente: IPaziente;
	residenza = false;
	recapito = false;
	reperibilita = false;

	writeCf: (cf: string) => void;
	calcolaCF: () => void;
	Date = toNgbDateStruct;

	codice_fiscale: Observable<string>;

	constructor(
		public readonly activeModal: NgbActiveModal,
		private readonly codice_fiscale$: CodiceFiscale,
		private readonly luoghi: Luoghi,
		private readonly modalService: NgbModal
	) {
		this.paziente = {
			id: null,
			nome: null,
			cognome: null,
			codicefiscale: null,
			dataNascita: null,
			recapito: {
				citta: null,
				pr: null,
				cap: null,
				indirizzo: null,
				numciv: null
			},
			residenza: {
				citta: null,
				pr: null,
				cap: null,
				indirizzo: null,
				numciv: null
			}
		};

		const _manualCf = new Subject<Observable<string>>();

		this.writeCf = (cf: string) => { _manualCf.next(Observable.of(cf)); };

		this.calcolaCF = () => {
			if (this.canComputeCF()) {
				_manualCf.next(codice_fiscale$.compute(
					this.paziente.nome.toLocaleUpperCase(),
					this.paziente.cognome.toLocaleUpperCase(),
					this.paziente.genere.toLocaleUpperCase(),
					this.paziente.dataNascita,
					this.paziente.luogoNascita.toLocaleUpperCase(),
					this.paziente.nazione.toLocaleUpperCase()
				));
			}
		};
		this.codice_fiscale = _manualCf.pipe(
			switchAll(),
			tap(cf => { this.paziente.codicefiscale = cf; })
		);
	}

	canComputeCF() {
		return !!this.paziente.nome &&
			!!this.paziente.cognome &&
			!!this.paziente.genere &&
			!!this.paziente.dataNascita &&
			!!this.paziente.luogoNascita &&
			!!this.paziente.nazione;
	}

	isWeekend(date: NgbDateStruct) {
		return moment({
			year: date.year,
			month: date.month - 1,
			day: date.day
		}).weekday() > 4;
	}

	toggleResidenza() {
		this.residenza = !this.residenza;
	}

	toggleRecapito() {
		this.recapito = !this.recapito;
	}

	toggleReperibilita() {
		this.reperibilita = !this.reperibilita;
	}

	async crea(paziente: IPaziente) {
		if (
			this.canComputeCF() &&
			paziente.codicefiscale != await this.codice_fiscale$.compute(
				this.paziente.nome.toLocaleUpperCase(),
				this.paziente.cognome.toLocaleUpperCase(),
				this.paziente.genere.toLocaleUpperCase(),
				this.paziente.dataNascita,
				this.paziente.luogoNascita.toLocaleUpperCase(),
				this.paziente.nazione.toLocaleUpperCase()
			).toPromise()
		) {
			const modalRef = this.modalService.open(AlertDialogComponent);
			modalRef.componentInstance.setMessage("Il campo codice fiscale non corrisponde ai dati inseriti. Sei sicuro di voler salvare ugualmente?");
			modalRef.componentInstance.setConfirm(true);
			modalRef.result.then((confirmed: boolean) => {
				if (confirmed) {
					this.activeModal.close(paziente);
				}
			}, () => { });
		} else {
			this.activeModal.close(paziente);
		}
	}

	typeahead(type: 'comuni' | 'nazioni', filterByNation, ...key: string[]) {
		const terms = this.luoghi[type] as Observable<any>;
		const _filter = (filterByNation || type == 'nazioni') ? 
			() => true : 
			() => (this.paziente.nazione||"ITALIA").toUpperCase() == "ITALIA";
		
		return (terms$: Observable<string>) => 
			terms$.pipe(
				filter(_filter),
				debounceTime(Config.searchDebounceTime),
				distinctUntilChanged(),
				combineLatest(
					terms.pipe(
						map((l => new Fuse(
							l,
							Object.assign(
								{}, 
								Config.fuse,
								{
									maxPatternLength: 16,
									threshold: 0.9,
									findAllMatches: false,
									keys: [ ...key ],
									minMatchCharLength: 3
								}
							)
						)))
					)
				),
				map(([term, luoghi]) => luoghi.search(term).splice(0, 5))
			);
	}

	typeaheadVie = (terms$: Observable<string>) => {
		return terms$.pipe(
			switchMap((term) => this.luoghi.searchVie(term))
		);
	}

	setLuogoNascita(value) {
		if (value) {
			if(isString(value)) {
				this.paziente.luogoNascita = value;
			} else {
				this.paziente.luogoNascita = value.citta;
				this.paziente.prNascita = value.pr || this.paziente.prNascita;
				this.paziente.nazione = "Italia";
			}
		}
	}

	setNazioneNascita(value) {
		if (value) {
			if(isString(value)) {
				this.paziente.nazione = value;
			} else {
				this.paziente.nazione = value.nome;
			}
		}
	}

	setVia(place: IPlace, via) {
		if(via) {
			if (isString(via)) {
				place.indirizzo = via;
			} else {
				place.indirizzo = `${via.tipo} ${via.nome}`;
				place.citta = via.citta;
				place.pr = via.pr;
				place.cap = via.cap;
			}
		}
	}

	setCitta(place: IPlace, citta) {
		if(citta) {
			if (isString(citta)) {
				place.citta = citta;
			} else {
				place.citta = citta.citta;
				place.pr = citta.pr;
				place.cap = citta.cap;
			}
		}
	}

	formatVia(via) {
		if (isString(via)) {
			return via;
		} else {
			return `${via.tipo} ${via.nome}`;
		}
	}

	formatCitta(citta) {
		if (isString(citta)) {
			return citta;
		} else {
			return citta.citta;
		}
	}

	formatNazione(nazione) {
		if (isString(nazione)) {
			return nazione;
		} else {
			return nazione.nome;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/anagrafica/newPatient/newPatient.ts